import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\GetListDocumentController::__invoke
* @see app/Http/Controllers/Document/GetListDocumentController.php
* @route '/api/document-migrator'
*/
const GetListDocumentController95a4c60703606884a3751e892d1b9973 = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetListDocumentController95a4c60703606884a3751e892d1b9973.url(options),
    method: 'get',
})

GetListDocumentController95a4c60703606884a3751e892d1b9973.definition = {
    methods: ["get","head"],
    url: '/api/document-migrator',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Document\GetListDocumentController::__invoke
* @see app/Http/Controllers/Document/GetListDocumentController.php
* @route '/api/document-migrator'
*/
GetListDocumentController95a4c60703606884a3751e892d1b9973.url = (options?: RouteQueryOptions) => {
    return GetListDocumentController95a4c60703606884a3751e892d1b9973.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\GetListDocumentController::__invoke
* @see app/Http/Controllers/Document/GetListDocumentController.php
* @route '/api/document-migrator'
*/
GetListDocumentController95a4c60703606884a3751e892d1b9973.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetListDocumentController95a4c60703606884a3751e892d1b9973.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Document\GetListDocumentController::__invoke
* @see app/Http/Controllers/Document/GetListDocumentController.php
* @route '/api/document-migrator'
*/
GetListDocumentController95a4c60703606884a3751e892d1b9973.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetListDocumentController95a4c60703606884a3751e892d1b9973.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Document\GetListDocumentController::__invoke
* @see app/Http/Controllers/Document/GetListDocumentController.php
* @route '/api/document'
*/
const GetListDocumentControllerc5da481f5489b079287b830734cb4c1e = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetListDocumentControllerc5da481f5489b079287b830734cb4c1e.url(options),
    method: 'get',
})

GetListDocumentControllerc5da481f5489b079287b830734cb4c1e.definition = {
    methods: ["get","head"],
    url: '/api/document',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Document\GetListDocumentController::__invoke
* @see app/Http/Controllers/Document/GetListDocumentController.php
* @route '/api/document'
*/
GetListDocumentControllerc5da481f5489b079287b830734cb4c1e.url = (options?: RouteQueryOptions) => {
    return GetListDocumentControllerc5da481f5489b079287b830734cb4c1e.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\GetListDocumentController::__invoke
* @see app/Http/Controllers/Document/GetListDocumentController.php
* @route '/api/document'
*/
GetListDocumentControllerc5da481f5489b079287b830734cb4c1e.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetListDocumentControllerc5da481f5489b079287b830734cb4c1e.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Document\GetListDocumentController::__invoke
* @see app/Http/Controllers/Document/GetListDocumentController.php
* @route '/api/document'
*/
GetListDocumentControllerc5da481f5489b079287b830734cb4c1e.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetListDocumentControllerc5da481f5489b079287b830734cb4c1e.url(options),
    method: 'head',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Document\GetListDocumentController::GetListDocumentController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `GetListDocumentController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const GetListDocumentController = {
    '/api/document-migrator': GetListDocumentController95a4c60703606884a3751e892d1b9973,
    '/api/document': GetListDocumentControllerc5da481f5489b079287b830734cb4c1e,
}

export default GetListDocumentController